/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class CloseIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="currentcolor" {...this.props}>
      <g id="close">
        <rect
          id="Rectangle"
          transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) "
          x="9.87867966"
          y="-2.8492424"
          width="4.24264069"
          height="29.6984848"
          rx="2.12132034"
        />
        <rect
          id="Rectangle"
          transform="translate(11.645252, 12.037992) rotate(-315.000000) translate(-11.645252, -12.037992) "
          x="9.64525202"
          y="-2.38185273"
          width="4"
          height="28.8396894"
          rx="2"
        />
      </g>
    </svg>;
  }
}

const Icon = pure(CloseIcon);
Icon.displayName = 'CloseIcon';
export default Icon;
